import { createSlice } from "@reduxjs/toolkit";

interface IStoresState {
  lang: 'ru' | 'en',
}

const initialState: IStoresState = {
  lang: 'en',
}

const storesSlice = createSlice({
  name: 'storesSlice',
  initialState,
  reducers: {
    setLang(state, action) {
      state.lang = action.payload
    },
  }
})
export default storesSlice.reducer;
export const { setLang } = storesSlice.actions
